import React from 'react';
import Svg from '../Svg';

const IconTarget01 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.05493 11H6C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13H3.05493C3.51608 17.1716 6.82838 20.4839 11 20.9451V18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18V20.9451C17.1716 20.4839 20.4839 17.1716 20.9451 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H20.9451C20.4839 6.82838 17.1716 3.51608 13 3.05493V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V3.05493C6.82838 3.51608 3.51608 6.82838 3.05493 11ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
    />
  </Svg>
);

export default IconTarget01;
